"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleUtilsDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.StyleUtilsDefinition = (0, static_service_1.defineStaticService)('viewer-core/viewer-service-style-utils');
//# sourceMappingURL=index.js.map